/**
 * Department Hierarchy — Parent → Child mapping
 *
 * The board approves at PARENT level (12 parent depts).
 * The forecast lives at CHILD dept × GL × month.
 * This file maps children to parents so we can roll up forecast
 * for ceiling comparison.
 *
 * Demo taxonomy for a generic engineering/operations org.
 *
 * Notes:
 * - Engineering is always part of Mechanical R&D
 * - "Operations" appearing as a single line in the forecast = director of
 *   Operations salary + external device components (sits inside Operations parent)
 */

export const deptHierarchy = {
  // parentId → array of forecast-tab child dept names (exact strings as they appear in the forecast)
  electrical_software: ['Electrical & Softwares'],
  mechanical_rd: ['Engineering', 'Mechanical Design'],
  operations: ['Operations', 'Machine Shop & Metrology', 'Cleanroom', 'Supply Chain', 'Facilities'],
  it: ['IT'],
  clinical_regulatory: ['Clinical & Regulatory'],
  quality: ['Quality'],
  design_control_testing: ['Design Control & Testing'],
  intellectual_property: ['Intellectual Property'],
  finances_legal: ['Finances & Legal'],
  people_culture: ['People & Culture'],
  executive: ['Executive'],
  commercial: [], // empty in FY26 — populated 2029+
};

// Reverse lookup: child dept name → parent id
export const childToParent = Object.entries(deptHierarchy).reduce(
  (acc, [parentId, children]) => {
    children.forEach((child) => {
      acc[child] = parentId;
    });
    return acc;
  },
  {}
);

/**
 * Given a child dept name, return its parent id.
 * Returns null if no mapping found (caller should treat as "uncategorized").
 */
export function parentOf(childDeptName) {
  return childToParent[childDeptName] || null;
}
